const initState = {
  isCreating: false,
  error: null,
}

export default initState
